

import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";

const AddNurse = ({ item,onAddDepart  }) => {
    const [formData, setFormData] = useState({
        user_id:'',
        nurse_rag_number: '',
        fname:'',
        mobile:'',
        city:'',
        state:'',
        address_line1:'',
        address_line2:'',
        nurse_depart: '',
        type: 'nurse',
        nurse_type: '',
        nurse_user:'',
        alertMsg: '',
        alertMsgTyp: '',
        isAlert: false,
      });
      const [ldata, setLdata] = useState(null);

      const handleChange = (e) => {
       
        const { name, value } = e.target;
        setFormData(prev => ({
          ...prev,
          [name]: value
        }));
      };

      const handleSubmit = async (e) => {
        e.preventDefault();
        // alert(formData.email+"");
        const fd = new FormData();
        fd.append('user_id', formData.user_id);
        fd.append('nurse_rag_number', formData.nurse_rag_number);
        fd.append('fname', formData.fname);
        fd.append('city', formData.city);
        fd.append('state', formData.state);
        fd.append('nurse_depart', formData.nurse_depart);
        fd.append('type', formData.type);
        fd.append('nurse_type', formData.nurse_type);
        fd.append('address_line1', formData.address_line1);
        fd.append('address_line2', formData.address_line2);
        fd.append('mobile', formData.mobile);
        fd.append('nurse_user', ldata.user_id);
        
        try {
            const response = await axios.post(AppConst.BASE_URL+AppConst.addUserUrl, fd, {
                headers: {
                'Content-Type': 'multipart/form-data',
                },
            });

            if(response.data.status){
               setFormData(prev => ({
                ...prev,
                user_id:'',
                nurse_rag_number: '',
                fname:'',
                mobile:'',
                city:'',
                state:'',
                address_line1:'',
                address_line2:'',
                nurse_depart: '',
                type: 'nurse',
                nurse_type: '',
                nurse_user:'',
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                  }));
                  document.getElementById("closeBt45").click();
                  onAddDepart();
            }
            else{
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                  }));
            }
        } catch (error) {
            setFormData(prev => ({
                ...prev,
                isAlert: true,
                alertMsg: "Failed",
                alertMsgTyp: "danger",
              }));
        }
        
      };

    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
        }  

        if (item) {
            console.log("Editing item:", item);
            if(item!=null && item!=undefined){
                setFormData(prev => ({
                    ...prev,
                    nurse_rag_number: item.doc.nurse_rag_number,
                    fname: item.fname,
                    city: item.city,
                    state: item.state,
                    nurse_depart: item.doc.nurse_depart,
                    type: item.type,
                    nurse_type: item.doc.nurse_type,
                    nurse_user: item.doc.nurse_user,
                    address_line1: item.address_line1,
                    address_line2: item.address_line2,
                    mobile: item.mobile,
                    user_id: item.user_id,
                  }));
                }
          }
          else{
            setFormData(prev => ({
                ...prev,
                user_id:'',
                nurse_rag_number: '',
                fname:'',
                mobile:'',
                city:'',
                state:'',
                address_line1:'',
                address_line2:'',
                nurse_depart: '',
                type: 'nurse',
                nurse_type: '',
                nurse_user:'',
              }));
          }
          
        return () => {
          console.log('Component unmounted');
        };
      }, [item]);

    return (
        <div class="modal fade" id="showModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                   <div class="modal-header bg-light p-3 d-flex justify-content-between align-items-center">
                        <h5 class="modal-title" id="exampleModalLabel">Add Nurse</h5>
                        
                            <button type="button" class="btn btn-sm btn-outline-primary d-inline-flex align-items-center edit-item-btn" data-bs-dismiss="modal" id="close-modal">
                            Close
                            </button>

                    </div>
                    <form class="tablelist-form" onSubmit={handleSubmit}>
                        <div class="modal-body">
                            <input id="id-field" type="hidden" />
                            <div class="row gy-4 mb-3">
                               
                                <div class="col-md-6">
                                    <div >
                                        <label for="customername-field" class="form-label">Name</label>
                                        <input id="customername-field" name="fname" onChange={handleChange} value={formData.fname} class="form-control" placeholder="Enter name" type="text"  required/>
                                    </div>
                                </div>
                                 <div class="col-md-6">
                                    <div id="modal-id">
                                        <label for="orderId" class="form-label">Reg. Number</label>
                                        <input id="orderId" class="form-control" name="nurse_rag_number" onChange={handleChange} value={formData.nurse_rag_number} placeholder="Reg. Number" type="text" required/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div>
                                        <label for="amount-field" class="form-label">Mobile</label>
                                        <input id="amount-field" name="mobile" onChange={handleChange} value={formData.mobile} class="form-control" placeholder="Mobile" type="text"  required/>
                                    </div>
                                </div>
                               

                                <div class="col-md-6">
                                    <div >
                                        <label for="date-field" class="form-label">Address Line 1</label>
                                        <input class="form-control" name="address_line1" onChange={handleChange} value={formData.address_line1} data-provider="flatpickr" placeholder="Address Line 1" type="text"  />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div >
                                        <label for="date-field" class="form-label">Address Line 2</label>
                                        <input class="form-control" name="address_line2" onChange={handleChange} value={formData.address_line2} data-provider="flatpickr" placeholder="Address Line 2" type="text" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div>
                                        <label for="amount-field" class="form-label">City</label>
                                        <input id="amount-field" name="city" onChange={handleChange} value={formData.city} class="form-control" placeholder="City" type="text"  />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div>
                                        <label for="amount-field" class="form-label">State</label>
                                        <input id="amount-field" name="state" onChange={handleChange} value={formData.state} class="form-control" placeholder="State" type="text"  />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div >
                                        <label for="date-field" class="form-label">Department</label>
                                        <input class="form-control" name="nurse_depart" onChange={handleChange} value={formData.nurse_depart} data-provider="flatpickr" placeholder="Department" type="text"  required/>
                                    </div>
                                </div>
                               
                                <div class="col-md-6">
                                    <div >
                                        <label for="date-field" class="form-label">Type</label>
                                        <input class="form-control" name="nurse_type" onChange={handleChange} value={formData.nurse_type} data-provider="flatpickr" placeholder="Type" type="text"  required/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="hstack gap-2 justify-content-end">
                                {/* <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button> */}
                                <button type="button" id="closeBt45" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                                {(formData.user_id.length>0)?<button type="submit" class="btn btn-success" id="edit-btn">Update</button>:<button type="submit" class="btn btn-success" id="edit-btn">Add</button>}
                                
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddNurse;
